<template>
  <v-container>
    <Dialog
      :show="adDialog"
      :correo="correo"
      :object="objDelete"
      @activate="activar"
      @email="enviarEmail"
      @deactivate="desactivar"
      @delete="eliminar"
      @close="close"
    />
    <Imprimir
      :reserva="true"
      :dialog="modalImprimir"
      :imprimir="imprimir"
      @close="close"
    />
    <template>
      <v-expansion-panels v-model="panel" :readonly="readonly" multiple>
        <v-row>
          <v-col cols="12" md="12">
            <Modal
              @save="guardar"
              @close="close"
              :object="itemAct"
              :update="update"
              :detalle="detalle"
              :show="abrirModal"
            />
          </v-col>
        </v-row>
        <v-expansion-panel>
          <v-expansion-panel-header class="headline">{{
            temporadasStr
          }}</v-expansion-panel-header>
          <v-col cols="12" md="4">
            <v-btn color="primary" dark class="mb-2" @click="nuevo"
              >Nuevo</v-btn
            >
          </v-col>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="12">
                <Table
                  @edit="editarClick"
                  @delete="eliminarClick"
                  @detalle="detalleClick"
                  @act="activarDesactivar"
                  @imprimir="imprimirClick"
                  @email="emailClick"
                  :headers="headersTemporadas"
                  :arrayList="temporadas"
                  :opciones="true"
                  :tarifas="true"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="headline">{{
            preciosStr
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  :items="temporadasSelect"
                  v-model="temporadaSelect"
                  label="Temporada"
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="10">
                <UploadExcel :on-success="handleSuccessBasic" :before-upload="beforeUpload" />
              </v-col>
              <v-col cols="12" md="12">
                <Table
                  @edit="editarClick"
                  @delete="eliminarClick"
                  @detalle="detalleClick"
                  @act="activarDesactivar"
                  @imprimir="imprimirClick"
                  @email="emailClick"
                  :headers="header"
                  :arrayList="dataPreciosBasic"
                  :opciones="true"
                  :tarifas="true"
                  :title="preciosBasicosStr"
                />
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="10">
                <UploadExcel :on-success="handleSuccessPremium" :before-upload="beforeUpload" />
              </v-col>
              <v-col cols="12" md="12">
                <Table
                  @edit="editarClick"
                  @delete="eliminarClick"
                  @detalle="detalleClick"
                  @act="activarDesactivar"
                  @imprimir="imprimirClick"
                  @email="emailClick"
                  :headers="header"
                  :arrayList="dataPreciosPremium"
                  :opciones="true"
                  :tarifas="true"
                  :title="preciosPremiumStr"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal from "@/components/base/modal/ModalTemporada.vue";
import Dialog from "@/components/base/Dialog";
import Imprimir from "@/components/base/Imprimir";
import Headers from "../headers";
import UploadExcel from "@/components/base/UploadExcel"

export default {
  data() {
    return {
      headersTemporadas: Headers.headersTemporadas,
      headersPreciosBasic: this.header,
      headersPreciosPremium: this.header,
      dataPreciosBasic: this.preciosBasic,
      dataPreciosPremium: this.preciosPremium,
      modoChart: "column",
      panel: [0, 1],
      adDialog: false,
      abrirModal: false,
      readonly: false,
      correo: false,
      temporadasSelect: [],
      temporadaSelect: null,
      temporadasStr: "Temporadas",
      preciosStr: "Precios por temporada",
      preciosBasicosStr: "Precios básicos",
      preciosPremiumStr: "Precios premium",
      message: null,
      itemAct: {},
      objDelete: {
        element: "Tarifa",
        adAccion: 0,
        adId: "",
        adNombre: "",
        id: "",
        obj: {},
      },
      imprimir: [],
      update: false,
      detalle: false,
      modalImprimir: false,
    };
  },
  components: {
    UploadExcel,
    Table,
    Modal,
    Dialog,
    Imprimir,
  },
  async created() {
    await this.getTemporadas(this.token);
    await this.formTitle();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("tarifasNamespace", ["preciosBasic", "preciosPremium"]),
    ...mapState("temporadasNamespace", ["temporada", "temporadas"]),
    header: () => {
      let value = [{ text: "Opciones", value: "opciones", sortable: false }];
      for (var i = 1; i <= 93; i++) {
        switch (i) {
          case 1:
            value.push({ text: "ID", value: "id", sortable: false });
            break;
          case 2:
            value.push({ text: "Grupo", value: "grupo", sortable: false });
            break;

          default:
            value.push({ text: `${i - 2}`, value: `${i - 2}`, sortable: true });
            break;
        }
      }
      return value;
    },
  },
  methods: {
    ...mapActions("tarifasNamespace", ["getPreciosBasic", "getPreciosPremium"]),
    ...mapActions("temporadasNamespace", [
      "getTemporadas",
      "getTemporada",
      "updateTemporada",
      "saveTemporada",
      "activateTemporada",
      "deactivateTemporada",
      "deleteTemporada",
    ]),
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.message = 'Please do not upload files larger than 1m in size.'
      return false
    },
    handleSuccessBasic({ results, header }) {
      debugger
      this.dataPreciosBasic = results
      this.headersPreciosBasic = header
    },
    handleSuccessPremium({ results, header }) {
      this.dataPreciosPremium = results
      this.headersPreciosPremium = header
    },
    async formTitle() {
      await this.temporadas.forEach((i) => {
        this.temporadasSelect.push({ text: i.nombre, value: i.id });
      });
    },
    editarClick(obj) {
      this.update = true;
      this.detalle = false;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    detalleClick(obj) {
      this.detalle = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    eliminarClick(obj) {
      this.adDialog = true;
      this.objDelete.id = obj.id;
      this.objDelete.obj = obj;
    },
    activarDesactivar(accion, item) {
      this.objDelete.adId = item.id;
      if (accion == 1) {
        this.objDelete.adAccion = 1; //"Activar Grupo"
        this.adDialog = true;
      } else if (accion == 2) {
        this.objDelete.adAccion = 2; //"Desactivar Grupo"
        this.adDialog = true;
      } else {
        this.adDialog = false;
      }
    },
    imprimirClick(obj) {
      let coches = this.coches;
      let marca = "";
      debugger;
      coches.forEach((e) => {
        if (obj.id_coche == e.id) {
          marca = e.marca;
        }
      });
      this.imprimir = [];
      this.imprimir.push({
        id_reserva: obj.id,
        tarifa: obj.tarifa,
        total: obj.total,
        id_cliente: obj.id_persona,
        nombre: obj.nombre,
        apellido: obj.apellido,
        telefono: obj.telefono,
        email: obj.email,
        id_coche: obj.id_coche,
        marca: marca,
        modelo: obj.coche_modelo,
        matricula: obj.coche_matricula,
        grupo: obj.coche_grupo,
        tipo_francdepos: obj.tipo_francdepos,
        valor_francdepos: obj.valor_francdepos,
        fecha_entrega: obj.fecha_entrega,
        fecha_recogida: obj.fecha_recogida,
        hora_entrega: obj.hora_entrega,
        hora_recogida: obj.hora_recogida,
        lugar_entrega: obj.lugar_entrega,
        lugar_recogida: obj.lugar_recogida,
        persona: obj.persona,
        extra: obj.extra,
        observaciones: obj.observaciones,
      });
      this.modalImprimir = true;
    },
    emailClick(obj) {
      this.objDelete.adAccion = 3;
      this.objDelete.adId = obj.id;
      this.objDelete.obj = obj;
      this.correo = true;
      this.adDialog = true;
    },
    nuevo() {
      this.update = false;
      this.abrirModal = true;
    },
    guardar(obj) {
      if (this.update) {
        this.updateTemporada({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveTemporada({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getCoches();
    },
    enviarEmail(obj) {
      debugger;
      this.sendEmail({
        token: this.token,
        res: obj,
      });
      this.close();
    },
    activar(id) {
      debugger;
      this.activateTemporada({
        token: this.token,
        id: id,
      });
      this.close();
    },
    desactivar(id) {
      debugger;
      this.deactivateTemporada({
        token: this.token,
        id: id,
      });
      this.close();
    },
    eliminar(obj) {
      debugger;
      this.deleteTemporada({
        token: this.token,
        id: obj,
      });
      this.close();
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.itemAct = {};
      this.abrirModal = false;
      this.adDialog = false;
      this.modalImprimir = false;
    },
  },
  watch: {
    temporadaSelect: function (val) {
      let data = { id: val, token: this.token };
      this.getTemporada(data);
    },
  },
};
</script>
